<template>
<div>
    <!-- loader -->
    <!--        <div class="loaders">-->
    <!--            <div class="loader"></div>-->
    <!--        </div>-->

    <Loader />
    <!-- loader -->

    <!-- invite-Modal -->
    <div class="modal fade" id="send_review_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog  modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Send Review Invite</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img class="img-fluid" src="@/assets/img/close.png" alt="image title">
                    </button>
                </div>
                <div class="modal-body">

                    <div class="contact-form">
                        <form>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="Customer">
                                        <p class="label-txt">Customer Name</p>
                                        <input type="text" class=" input" id="Customer">
                                    </label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="CustomerEmial">
                                        <p class="label-txt">Customer Phone/Email</p>
                                        <input type="email" class=" input" id="CustomerEmial">
                                    </label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="Language">
                                        <p class="label-txt">Language</p>
                                        <select class="input" id="Language" aria-label="Language">
                                            <option></option>
                                            <option>English</option>
                                            <option>English</option>
                                            <option>English</option>
                                            <option>English</option>
                                        </select>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="text-center">
                        <button type="submit" class="send-btn" data-toggle="modal" data-target="#exampleModal2" data-dismiss="modal"><img class="img-fluid" src="@/assets/img/plane.svg" alt="image title"> Send Review
                            Invite
                        </button>
                        <a class="multi" href="#" data-toggle="modal" data-target="#exampleModal6" data-dismiss="modal">Send
                            Multiple</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- invite-Modal -->
    <div class="modal fade" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
        <div class="modal-dialog  modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel2"></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img class="img-fluid" src="@/assets/img/close.png" alt="image title">
                    </button>
                </div>
                <div class="modal-body">

                    <div class="contact-form">
                        <div class="after-invite">
                            <img class="img-fluid" src="@/assets/img/log.svg" alt="image title">
                            <p>Invitation sent 19 munites ago</p>
                            <h4>Shahin <span>(+1 801 667 0552)</span></h4>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="text-center">
                        <button type="submit" class="send-btn" data-toggle="modal" data-target="#exampleModal3" data-dismiss="modal">Send Invite Anyway
                        </button>
                        <a class="multi" href="#">Back</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- invite-Modal -->
    <div class="modal fade" id="exampleModal3" tabindex="-1" aria-labelledby="exampleModalLabel3" aria-hidden="true">
        <div class="modal-dialog  modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel3"></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img class="img-fluid" src="@/assets/img/close.png" alt="image title">
                    </button>
                </div>
                <div class="modal-body">

                    <div class="contact-form">
                        <div class="after-invite">
                            <img class="img-fluid" src="@/assets/img/succ.svg" alt="image title">
                            <p class="succ">Review Invite Sent</p>
                            <h4>Shahin <span>(+1 801 667 0552)</span></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- locations -->
    <div class="locations-modal">
        <!-- locations-head -->
        <div class="locations-head">
            <div class="modal-header">
                <h5 class="modal-title"> Locations</h5>
                <button type="button" class="close clx">
                    <img class="img-fluid" src="@/assets/img/close-w.png" alt="image title">
                </button>
            </div>

            <div class="search-box">
                <form>
                    <div class="form-group">
                        <input type="search" class="form-control" placeholder="Search" aria-label="search">
                        <img class="img-fluid sea-icon" src="@/assets/img/search.svg" alt="image title">
                    </div>
                </form>
            </div>
        </div>
        <!-- locations-head -->

        <!-- location-list -->
        <div class="locations-list">
            <ul class="all-list">
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a></li>
                <li><a href="#">last Schulist Ltd <p>2130 George Avenue, Louisville, KY, Kentucky 40261, USA</p></a>
                </li>
            </ul>
        </div>
        <!-- location-list -->

    </div>
    <!-- locations -->

    <!-- invite-Modal -->
    <div class="modal fade" id="exampleModal9" tabindex="-1" aria-labelledby="exampleModalLabel9" aria-hidden="true">
        <div class="modal-dialog  modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel9">Send Invite</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img class="img-fluid" src="@/assets/img/close.png" alt="image title">
                    </button>
                </div>
                <div class="modal-body">

                    <div class="contact-form">
                        <form>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="customername">
                                        <p class="label-txt">Customer Name</p>
                                        <input type="text" class=" input" id="customername">
                                    </label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="customerphone">
                                        <p class="label-txt">Customer Phone</p>
                                        <input type="email" class=" input" id="customerphone">
                                    </label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="customeremial">
                                        <p class="label-txt">Customer Email</p>
                                        <input type="email" class=" input" id="customeremial">
                                    </label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="send-btn"><img class="img-fluid" src="@/assets/img/plane.svg" alt="image title"> Send
                                    Invite
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- main-area -->
    <section class="main-area">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <LeftNav />

                    <!-- main-contents -->
                    <div class="main-contents">
                        <TopHeader :Logout="logout" :RouteObject="Route" :openDialpadModal="openDialpadModal" />

                        <slot />

                    </div>
                    <!-- main-contents -->

                </div>
            </div>
        </div>
    </section>
    <!-- main-area -->

    <!-- Dialpad -->
    <!-- Modal -->
    <div class="modal fade" id="DailPad" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Dialpad </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="!DialpadInCall" @click="closeDialpadModal">
                        <img class="img-fluid" src="@/assets/img/close.png" alt="image title">
                    </button>
                </div>
                <div class="modal-body p-0">
                    <div class="dialer">
                        <div class="numberfield">
                            <input id="number" type="text" placeholder="Enter number..." v-model="CustomerPhoneNumber" @input="onDialpadNumberInput" />
                            <button id="backBtn" class="btn">⌫</button>
                        </div>
                        <div class="keys">
                            <button class="btndial">1</button>
                            <button class="btndial">2</button>
                            <button class="btndial">3</button>
                            <button class="btndial">4</button>
                            <button class="btndial">5</button>
                            <button class="btndial">6</button>
                            <button class="btndial">7</button>
                            <button class="btndial">8</button>
                            <button class="btndial">9</button>
                            <button class="btndial">&nbsp;</button>
                            <button class="btndial">0</button>
                            <button class="btndial">&nbsp;</button>
                        </div>

                        <div class="actions">
                            <button id="callBtn" class="btn call" v-if="!DialpadInCall" @click="checkOrCreateCustomerChat()"><i class="fa fa-phone" aria-hidden="true"></i> Start Call</button>
                            <!-- shown only when call in progress -->
                            <button id="endUpdateBtn" class="btn cancel" v-if="DialpadInCall" @click="DialpadCallend('update')"><i class="fa fa-upload" aria-hidden="true"></i> End and Update</button>
                            <button id="endCallBtn" class="btn cancel" :disabled="!DialpadInCall" v-if="DialpadInCall" @click="DialpadCallend"><i class="fa fa-times" aria-hidden="true"></i> End Call</button>
                        </div>

                        <div id="status">{{ DialpadCallstatus }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="modal fade" id="information" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Update Customer</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img class="img-fluid" src="@/assets/img/close.png" alt="image title">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="contact-form">
                        <form action="#" method="POST">
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="Company">
                                        <p class="label-txt label-active">Company</p>
                                        <input type="text" class="input" id="customer-Company" v-model="updateDialedCustomer.company_name">
                                    </label>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="First">
                                    <p class="label-txt label-active">First Name</p>
                                    <input type="text" class="input" id="customer-First" v-model="updateDialedCustomer.first_name">
                                </label>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="Last">
                                    <p class="label-txt label-active">Last Name</p>
                                    <input type="text" class="input" id="customer-Last" v-model="updateDialedCustomer.last_name">
                                </label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="Email">
                                    <p class="label-txt label-active">Email Address</p>
                                    <input type="email" class=" input" id="customer-Email" v-model="updateDialedCustomer.email_address">
                                </label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="Phone">
                                    <p class="label-txt label-active">Phone Number</p>
                                    <input type="text" class=" input" id="customer-Phone" v-model="updateDialedCustomer.phone_no" readonly>
                                </label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="Status">
                                        <p class="label-txt label-active">Status</p>
                                        <select class="form-select form-control" id="customer-status" v-model="updateDialedCustomer.status">
                                            <option value="">Select Status</option>
                                            <option value="Answered">Answered</option>
                                            <option value="No answer">No answer</option>
                                            <option value="Not interested">Not interested</option>
                                            <option value="Wrong number">Wrong number</option>
                                            <option value="Meeting booked">Meeting booked</option>
                                            <option value="Asked to be called later">Asked to be called later</option>
                                        </select>
                                    </label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="Status">
                                        <p class="label-txt label-active">Notes</p>
                                        <textarea type="text" class="input" id="customer-notes" v-model="updateDialedCustomer.notes"></textarea>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="text-center">
                        <button type="button" class="btn btn-primary" @click="updateDialpadCustomer()">
                            Save Customer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Dialpad -->
</div>
</template>

<style>
@import "https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700;900&display=swap";
@import "../assets/css/bootstrap.min.css";
@import "../assets/css/font-awesome.min.css";
@import "../assets/css/apexcharts.css";
/*@import "./assets/css/jquery-ui.min.css";*/
@import "../assets/css/daterangepicker.css";
@import "../assets/css/jquery.dataTables.min.css";
@import "../assets/css/responsive.dataTables.min.css";
@import "../assets/css/style.css?v=1.008";
@import "../assets/css/responsive.css";

table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control:before,
table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control:before {
    background-color: #2A4385;
}

table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,
table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before {
    background-color: #d33333 !important;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/*.button-wrapper .label .img-fluid{*/
/*    border-radius: 50%;*/
/*    overflow: hidden;*/
/*    width: 100px;*/
/*    height: 100px;*/
/*    object-fit: cover;*/
/*}*/
/*.team-name .img-fluid{*/
/*    border-radius: 50%;*/
/*    overflow: hidden;*/
/*    width: 100px;*/
/*    height: 100px;*/
/*    object-fit: cover;*/
/*}*/
</style>

<script>
import $ from "jquery";
import LeftNav from "./../common/LeftNav.vue";
import TopHeader from "./../common/TopHeader.vue";
import "select2";
// import "daterangepicker";
import "datatables.net";
import "datatables.net-responsive";
import {
    useRoute,
    useRouter
} from "vue-router";
import axios from "axios";
import {
    onMounted,
    ref,
    onUnmounted
} from "vue";
import Loader from "@/components/Loader";
// import { getToken, messaging, onMessage } from "../firebase";
// import api from "../use/api";
// import { useChatMessagesStore } from "../stores/chatMessages";
import {
    useAuthUserStore
} from "../stores/auth";
import { initDevice, makeCall, endAllCalls, cleanupDevice } from '@/services/twilioVoice'
import Pusher from "pusher-js";

const sound = require("@/assets/notification/bell.mp3");
// console.log(sound);

export default {
    components: {
        Loader,
        LeftNav,
        TopHeader,
    },
    setup() {

        const Router = useRouter();
        const Route = useRoute();
        //Router.push("/inbox");

        // Twilio Call Feature
        const DialpadCallloading = ref(false);
        const DialpadCallready = ref(false);
        const DialpadCallstatus = ref('Idle');
        const DialpadInCall = ref(false);
        let DialpadCalltoken = null;
        // Twilio Call Feature
        // Keep track of current call
        let currentCall = null;
        let CustomerPhoneNumber = ref('');
        let DialpadCustomerId = ref(0);
        let DialpadCurrentChat = ref([]);
        const logged_in_user_id = localStorage.getItem('user_id');
        const logged_in_dealer_id = localStorage.getItem('dealer_id');
        let updateDialedCustomer = ref({
            company_name: '',
            first_name: '',
            last_name: '',
            email_address: '',
            phone_no: '',
            status: 1,
            notes: ''
        });
        
        // Watch CustomerPhoneNumber and sync to updateDialedCustomer
        const syncPhoneNumber = () => {
            updateDialedCustomer.value.phone_no = CustomerPhoneNumber.value;
        };

        // Input handler to allow only digits (max 10) and keep Vue model in sync
        const onDialpadNumberInput = (e) => {
            try {
                const raw = String(e.target.value || '');
                const digits = raw.replace(/\D/g, '').slice(0, 10);
                if (e.target.value !== digits) e.target.value = digits;
                CustomerPhoneNumber.value = digits;
            } catch (err) {
                console.log('onDialpadNumberInput error', err);
            }
        };

        // Read if localstorage changed for logged in user session and logout the tabs
        const clickSound = async () => {
            const audio = new Audio(sound);
            audio.play();
        }
        if (!localStorage.getItem("auth_token")) {
            window.location.href = '/?' + new Date().getTime();
        }

        const unReadRepliedChatsCount = async () => {
            const getFormData = new FormData();
            getFormData.append('dealer_id', localStorage.getItem('dealer_id'));
            getFormData.append('location_id', localStorage.getItem('location_id'));
            await axios
                .post(
                    axios.defaults.baseUrl + "unreadChatcount",
                    getFormData, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('auth_token'),
                        },
                    }
                )
                .then((response) => {
                    if (response.data.data.unread_count > 0) {
                        console.log(response.data.data.unread_count);
                        $('.menu ul li a i.fa-beat').show();
                        // var baseUrl = window.location.origin;
                    }else{
                        $('.menu ul li a i.fa-beat').hide();
                    }
                    // unreadChatCount.value = response.data.data.unread_count;
                })
                .catch((error) => {
                    console.log(error);
                    // window.showHideMainLoader(false);
                    //showToast(error.response.data.status, error.response.data.message);
                    return false;
                });
        }

        const openDialpadModal = () => {
            DialpadCallstatus.value = 'Idle...';
            CustomerPhoneNumber.value = '';
            $('#DailPad').modal('show');
        }
        const closeDialpadModal = () => {
            CustomerPhoneNumber.value = '';
            $('#DailPad').modal('hide');
        }
        const showToast = (toastIcon, toastMessage) => {
            window.toast.fire({
                icon: toastIcon,
                title: toastMessage,
            });
        }
        // Keypad buttons: if call is active, send DTMF; otherwise append to input field.
        $(".keys .btndial").on("click", function() {
            const ch = $(this).text();
            // ignore non-digit keys (e.g. blanks or symbols)
            if (!/\d/.test(ch)) return;
            
            if (DialpadInCall.value) {
                // Call is in progress: send digit via Twilio
                pressDigit(ch);
            } else {
                // No call: append digit to input field
                DialpadCallstatus.value = '';
                const current = $("#number").val() || '';
                const newVal = (current + ch).replace(/\D/g, '').slice(0, 10);
                $("#number").val(newVal);
                CustomerPhoneNumber.value = newVal;
            }
        });

        // Backspace — now works reliably and syncs Vue model
        $("#backBtn").on("click", function() {
            DialpadCallstatus.value = '';
            const v = $("#number").val() || '';
            const newVal = v.slice(0, -1).replace(/\D/g, '').slice(0, 10);
            $("#number").val(newVal);
            CustomerPhoneNumber.value = newVal;
        });

        // Call
        // $("#callBtn").on("click", function() {
        //     const num = $("#number").val().trim();
        //     if (!num) {
        //         $("#status").text("Please enter a number.");
        //         return;
        //     }
        //     $("#status").text("Calling " + num + " …");
        // });

        // Cancel clears input and status
        // $("#cancelBtn").on("click", function() {
        //     $("#number").val("");
        //     $("#status").text("Canceled.");
        // });

        // Keyboard support: Enter to call, Escape to clear
        // $(document).on("keydown", function(e) {
        //     if (e.key === "Enter") $("#callBtn").click();
        //     if (e.key === "Escape") $("#cancelBtn").click();
        // });
/* _____  _____ */
/* _____ Twilio Call Feature _____*/

        const updateDialpadCustomer = async () => {
            // Validate customer ID exists
            if (!DialpadCustomerId.value || DialpadCustomerId.value <= 0) {
                showToast("error", "No customer selected. Please create or select a customer first.");
                return false;
            }

            // Collect form data from Vue model (updateDialedCustomer)
            const formData = new FormData();
            formData.append('customer_id', DialpadCustomerId.value);
            formData.append('company', updateDialedCustomer.value.company_name || '');
            formData.append('first_name', updateDialedCustomer.value.first_name || '');
            formData.append('last_name', updateDialedCustomer.value.last_name || '');
            formData.append('email', updateDialedCustomer.value.email_address || '');
            formData.append('phone', updateDialedCustomer.value.phone_no || '');
            formData.append('optin_status', (typeof updateDialedCustomer.value.status !== 'undefined') ? updateDialedCustomer.value.status : 1);
            formData.append('notes', updateDialedCustomer.value.notes || '');
            formData.append('dealer_id', localStorage.getItem('dealer_id'));
            formData.append('location_id', localStorage.getItem('location_id'));

            window.showHideMainLoader(true);

            try {
                const response = await axios.post(
                    axios.defaults.baseUrl + "customers/update/" + DialpadCustomerId.value,
                    formData,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('auth_token'),
                        },
                    }
                );

                window.showHideMainLoader(false);

                if (response.data?.status === "success") {
                    showToast("success", response.data?.message || "Customer updated successfully.");
                    // If the current page is inbox/all, reload to refresh the list/context
                    try {
                        const path = window.location.pathname || '';
                        if (/\/inbox\/all\/?$/.test(path)) {
                            window.location.reload();
                        }
                    } catch (e) {
                        console.log('reload check error', e);
                    }
                    // After successful update ensure Start Call is available again
                    DialpadInCall.value = false;
                    // Reset Vue model (keep phone in sync if you prefer)
                    updateDialedCustomer.value = {
                        company_name: '',
                        first_name: '',
                        last_name: '',
                        email_address: '',
                        phone_no: '',
                        status: 1,
                        notes: ''
                    };
                    $('#information').modal('hide');
                    return true;
                } else {
                    showToast("error", response.data?.message || "Failed to update customer.");
                    return false;
                }
            } catch (error) {
                console.log(error);
                window.showHideMainLoader(false);
                showToast(error.response?.data?.status || "error", error.response?.data?.message || "An error occurred while updating customer.");
                return false;
            }
        }
        const checkOrCreateCustomerChat = async () => {
            DialpadCallstatus.value = '📞 Initializing Call...';
            // Read value from Vue ref or fallback to the input (in case jQuery modified it)
            const raw = String(CustomerPhoneNumber.value || $("#number").val() || "").trim();
            // strip all non-digits
            const digits = raw.replace(/\D/g, "");

            // Normalize to a 10-digit US number:
            // - If 11 digits and starts with '1', drop the leading '1'
            // - If already 10 digits, keep as-is
            let normalized = "";
            if (digits.length === 11 && digits.startsWith("1")) {
                normalized = digits.slice(1);
            } else if (digits.length === 10) {
                normalized = digits;
            }

            // Validate result
            if (!/^\d{10}$/.test(normalized)) {
                DialpadCallstatus.value = 'Idle...';
                showToast("error", "Please enter a valid 10-digit phone number.");
                return;
            }

            // write normalized number back to Vue ref and the input so UI stays in sync
            CustomerPhoneNumber.value = normalized;
            $("#number").val(normalized);

            window.showHideMainLoader(true);
            const getFormData = new FormData();
            getFormData.append('dealer_id', localStorage.getItem('dealer_id'));
            getFormData.append('location_id', localStorage.getItem('location_id'));
            getFormData.append('phone_number', normalized);
            await axios
                .post(
                    axios.defaults.baseUrl + "twilio/chat/create_from_dialpad",
                    getFormData, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('auth_token'),
                        },
                    }
                )
            .then((response) => {
                if (response.data?.data?.customer_id > 0) {
                    DialpadCustomerId.value = response.data.data.customer_id;
                    DialpadCurrentChat.value = response.data.data.currentChat;
                    window.showHideMainLoader(false);
                    DialpadCallinit();
                } else {
                    window.showHideMainLoader(false);
                }
            })
            .catch((error) => {
                console.log(error);
                window.showHideMainLoader(false);
                showToast(error.response?.data?.status || "error", error.response?.data?.message || "An error occurred.");
                return false;
            });
        }
        // Initialize device
        const DialpadCallinit = async () => {
            window.showHideMainLoader(true);
            try {
                DialpadCallloading.value = true
                DialpadCallstatus.value = 'Fetching Twilio token...'

                const res = await fetch('https://api.getstreamly.com/api/twilio/token')
                const data = await res.json()
                DialpadCalltoken = data.token

                await initDevice(DialpadCalltoken)
                DialpadCallstatus.value = '✅ Device ready'
                DialpadCallready.value = true;
                DialpadCallmake();
            } catch (err) {
                // console.error(err)
                DialpadCallstatus.value = '❌ Initialization failed'
            } finally {
                DialpadCallloading.value = false
            }
        }

        // Make outbound call
        const DialpadCallmake = async () => {
            try {
                DialpadCallstatus.value = '📞 Dialing...';
                currentCall = await makeCall({
                    To: '+1'+CustomerPhoneNumber.value,
                    // To: '+15595336954',
                    dealerId: logged_in_dealer_id,
                    chatId: DialpadCurrentChat.value?.id,
                    userId: logged_in_user_id
                })
                console.log('📞 Outgoing call SID:', currentCall.parameters.CallSid);
                // mark that a call is active
                DialpadInCall.value = true;
                attachCallEvents(currentCall);
            } catch (err) {
                DialpadCallstatus.value = '❌ Failed to start call'
                DialpadInCall.value = false;
            }
        }
        // Send digits during the call
        const pressDigit = (digit) => {
            if (currentCall) {
                console.log('🎹 Sending DTMF:', digit)
                currentCall.sendDigits(digit)
            }
        }

        const DialpadCallend = async (updateCheck = null) => {
            await endAllCalls()
            currentCall = null
            DialpadCallstatus.value = '📴 Call ended';
            DialpadInCall.value = false;
            if(updateCheck === 'update'){
                DialpadCallstatus.value = '';
                $('#DailPad').modal('hide');
                $('#information').modal('show');
                syncPhoneNumber();
            }
        }

        // Watch call events
        function attachCallEvents(call) {
            call.on('ringing', () => (DialpadCallstatus.value = '🔔 Ringing...'))
            call.on('accept', () => (DialpadCallstatus.value = '🟢 Call in progress'))
            call.on('disconnect', () => {
                DialpadCallstatus.value = '📴 Call ended'
                currentCall = null
            })
            call.on('error', (err) => {
                // console.error('Call error:', err)
                DialpadCallstatus.value = `❌ Error: ${err.message}`
            })
        }

        // Clean up on unmount
        onUnmounted(async () => {
            await cleanupDevice()
        })
/* _____ Twilio Call Feature _____*/

        onMounted(() => {
            // Keypad buttons: if call is active, send DTMF; otherwise append to input field.
            $(".keys .btndial").on("click", function() {
                const ch = $(this).text();
                if (!/\d/.test(ch)) return;
                
                if (DialpadInCall.value) {
                    // Call is in progress: send digit via Twilio
                    pressDigit(ch);
                } else {
                    // No call: append digit to input field
                    const current = $("#number").val() || '';
                    const newVal = (current + ch).replace(/\D/g, '').slice(0, 10);
                    $("#number").val(newVal);
                    CustomerPhoneNumber.value = newVal;
                    $("#status").text("");
                }
            });

            // Backspace
            $("#backBtn").on("click", function() {
                const v = $("#number").val() || '';
                const newVal = v.slice(0, -1).replace(/\D/g, '').slice(0, 10);
                $("#number").val(newVal);
                CustomerPhoneNumber.value = newVal;
                $("#status").text("");
            });

            // Call
            // $("#callBtn").on("click", function() {
            //     const num = $("#number").val().trim();
            //     if (!num) {
            //         $("#status").text("Please enter a number.");
            //         return;
            //     }
            //     $("#status").text("Calling " + num + " …");
            // });

            // Cancel clears input and status
            // end-call (plain end)
            // $("#endCallBtn").on("click", function() {
            //     $("#number").val("");
            //     $("#status").text("Canceled.");
            // });
            // end-and-update (if you need a jQuery hook)
            $("#endUpdateBtn").on("click", function() {
                // nothing here — handled by Vue
            });

            // Keyboard support: Enter to call, Escape to clear
            // $(document).on("keydown", function(e) {
            //     if (e.key === "Enter") $("#callBtn").click();
            //     if (e.key === "Escape") $("#cancelBtn").click();
            // });
            const authStore = useAuthUserStore();
            authStore.loadUserInfo();
            // Loader Fadeout
            // $(".loaders").fadeOut();
            // Collapse Menu
            $(".menuwidth").click(function () {
                $(".menu-area").toggleClass("menu-full");
                $(".hide-item").toggleClass("show-item");
                $(".small-logo").toggleClass("show-logo");
                $(".main-contents").toggleClass("menu-full-body");
            });
            // select 2
            $(".select2").select2();
            //tabs responsive
            $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
                console.log(e);
                $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
            });
            $(".display :checkbox").change(function () {
                $(this).parent().parent().toggleClass("selecet-bg");
            });
            $(".display :checkbox").change(function () {
                $(this).parent().parent().parent().toggleClass("selecet-bg");
            });
            $(".display :checkbox").change(function () {
                if ($(this).is(":checked")) {
                    $(".carpost-area").addClass("show-car");
                } else {
                    $(".carpost-area").removeClass("show-car");
                }
            });
            // Select 2 Two Way binding
            $(".select2")
                .select2()
                .on("select2:select", (e) => {
                    const event = new Event("change", {
                        bubbles: true,
                        cancelable: true
                    });
                    e.params.data.element.parentElement.dispatchEvent(event);
                })
                .on("select2:unselect", (e) => {
                    const event = new Event("change", {
                        bubbles: true,
                        cancelable: true
                    });
                    e.params.data.element.parentElement.dispatchEvent(event);
                });
            unReadRepliedChatsCount();
        });
        /*----Pusher Message Start----*/
        const pusher = new Pusher('3f202806c5b779461f0b', {
          cluster: 'ap2',
        });
        const pusher_channel_name_sound = "streamly-channel-"+localStorage.getItem('dealer_id');
        const pusher_event_open_sound = "chat-message-open";
        const channel_open = pusher.subscribe(pusher_channel_name_sound);
        channel_open.bind(pusher_event_open_sound, (payload) => {
          console.log(payload);
          clickSound();
          unReadRepliedChatsCount();
        });
        /*----Pusher Message End----*/
        return {
            Route,
            Router,
            unReadRepliedChatsCount,
            clickSound,

            openDialpadModal,
            closeDialpadModal,
            DialpadCallloading,
            DialpadCallready,
            DialpadCallstatus,
            DialpadCalltoken,

            checkOrCreateCustomerChat,
            DialpadCallinit,
            DialpadCallmake,
            DialpadCallend,

            CustomerPhoneNumber,
            DialpadCurrentChat,
            DialpadCustomerId,

            updateDialedCustomer,
            updateDialpadCustomer,
            syncPhoneNumber,
            onDialpadNumberInput,
            pressDigit,
            DialpadInCall
        }
    },

    created() {
        /** /
            // start  function update  token
            const { sendPostRequest } = api();
            getToken(messaging, { vapidKey: 'BE9yPw-x6Na46UsMnP-eF3_23HTBF1K-gBbDKWBiiqQ1QcqSGp2GDiC6cakTAb8_JtMYAKRDYMCwkQp5pghlGno' })
              .then((currentToken) => {

                if (currentToken) {

                  localStorage.setItem("FCM-Token", currentToken)

                  sendPostRequest('updateFcmToken', {
                    'fcm_token': currentToken
                  });
                  console.log("FCM-Token", currentToken);

                } else {
                  console.log('No registration token available. Request permission to generate one.');
                }
              }).catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
              });
            /// end function to update token

            onMessage(messaging, (payload) => {

              if (parseInt(payload.data.msgType) === 2) { /// if  chat
                const chatStore = useChatMessagesStore();
                // this.$route.name;

                chatStore.addNewMessageFromNotification(JSON.parse(payload.data.message), payload.data.target_id)
                /// if route message
                // if (this.$route.name === 'Messages') { // if current route is
                //
                // }
                console.log('Message received ', this.$route);

              }
              console.log('Message received ', payload.data.msgType);
              console.log(JSON.parse(payload.data.message));
              console.log('Message received ', payload.data.target_id);
              console.log('Message received.111 ', payload);

              // counter.value++;
              // createToast({ title: payload.notification.title, description: payload.notification.body }, { type: 'info' });

            });
            /// end function to receive  fcm notification
        /**/

    },
    methods: {
        logout: async () => {
            // console.log('logout')
            axios
                .post(axios.defaults.baseUrl + "logout")
                .then((response) => {
                    if (response) {
                        localStorage.clear();
                        // localStorage.removeItem("auth_token");
                        // localStorage.removeItem("user");
                        // localStorage.removeItem("user_id");
                        // localStorage.removeItem("dealer");
                        // localStorage.removeItem("dealer_id");
                        // localStorage.removeItem("user_type");
                        // localStorage.removeItem("first_name");
                        // localStorage.removeItem("last_name");
                        // localStorage.removeItem("permissions");
                        window.toast.fire({
                            icon: "success",
                            title: "User is logout successfully",
                        });
                        window.location.href = '/login?' + new Date().getTime();
                    }
                })
                .catch(() => {
                    localStorage.clear();
                    // localStorage.removeItem("auth_token");
                    // localStorage.removeItem("user");
                    // localStorage.removeItem("user_id");
                    // localStorage.removeItem("dealer");
                    // localStorage.removeItem("dealer_id");
                    // localStorage.removeItem("user_type");
                    window.location.href = '/login?' + new Date().getTime();
                });
        }
    }

};
</script>
